<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">성과보고서</span>
            <span class="txt">
                전체 직원의 매출/급여 를 확인하고, 직원 한 명의 자세한 매출/급여를 확인 및 금액수정을 할 수 있습니다.
            </span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="['선택', ...statusType]"
                    :select-value="['', ...statusTypeValue]"
                    :selected-value="status"
                    @update:set="
                        (val) => {
                            status = val;
                            this.staffId = '';
                            this.fetchCenterStaffAllList();
                        }
                    "
                ></select-form>
                <select-form
                    :disabled="isDisableSelectStaffs"
                    :select-data="selectFormStaff.data"
                    :select-value="selectFormStaff.value"
                    :selected-value="staffId"
                    class="w160"
                    @update:set="onSelectedStaff"
                ></select-form>
                <div class="com-calendar-wrap center">
                    <button class="prev-day" @click="onClickBtnPrevMonth"></button>
                    <div class="ui-month-calendar">
                        <vue-monthly-picker v-model="monthlyPicker" dateFormat="YYYY년 MM월"></vue-monthly-picker>
                    </div>
                    <button class="next-day" @click="onClickBtnNextMonth"></button>
                </div>
                <div class="right">
                    <!-- <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button> -->
                </div>
            </div>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <span v-else>
            <div class="com-table-top">
                <span class="title">
                    개인 회원
                    <div class="com-tooltip right">
                        도움말
                        <button class="icon"></button>
                        <div class="detail big">
                            <div class="division-wrap">
                                <div class="info-area">
                                    <span class="tit">소진금액</span>
                                    <p class="txt">1회당 단가 x 사용횟수</p>
                                    <span class="tit">잔여금액</span>
                                    <p class="txt">
                                        해당 직원이 담당강사로 배정 된 유효 회원의 구매가에서
                                        <br />
                                        소진금액을 제외하고 남은 누적잔여금액의 총 합계.
                                        <br />
                                        <br />

                                        예시)
                                        <br />
                                        결제금액 : 10회 500,000원
                                        <br />
                                        회당 단가 50,000원
                                        <br />
                                        수업 3회 사용완료인 경우
                                        <br />
                                        소진매출 : 150,000원
                                        <br />
                                        잔여금액 : 350,000원
                                    </p>
                                    <p class="txt red">
                                        ※ 소진금액, 잔여금액은 이용권의 횟수가 정해져 있는 '총 N회'인 이용권의
                                        합계입니다. 주 N회/무제한 횟수의 이용권은 정확한 금액을 환산할 수 없으므로
                                        산출하지 않습니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 90px" />
                        <col style="width: 100px" />
                        <col style="width: 270px" />
                        <col style="width: 100px" />
                        <col style="width: 60px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 80px" />
                        <col style="width: 100px" />
                        <col style="width: 120px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><button>회원명</button></th>
                            <th><button>시작일</button></th>
                            <th><button>이용권명</button></th>
                            <th><button>구매가</button></th>
                            <th><button>횟수</button></th>
                            <th><button>회당단가</button></th>
                            <th><button>사용횟수</button></th>
                            <th><button>소진금액</button></th>
                            <th><button>정산금액</button></th>
                            <th><button>잔여횟수</button></th>
                            <th><button>잔여금액</button></th>
                            <th><button>종료일자</button></th>
                            <th><button>등록횟수</button></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(p, index) in person.list"
                            :key="index"
                            :class="{ gray: p.orgLessonStaffId !== selectedStaffId }"
                        >
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${p.centerId}`,
                                        query: { customerId: p.centerCustomerId },
                                    }"
                                    class="link"
                                >
                                    {{ p.centerCustomerName }}
                                </router-link>
                            </td>
                            <td>{{ p.expireStartDate | timestampFilter }}</td>
                            <td>
                                {{ convertTicket(p.ticketType) }}
                                <router-link
                                    :to="{
                                        path: `/madmin/member/account/${p.centerId}`,
                                        query: { customerId: p.centerCustomerId, contractId: p.centerContractId },
                                    }"
                                    class="link"
                                >
                                    {{ p.productName }}
                                </router-link>
                                ({{ p.lessonTime }}분)
                            </td>
                            <td>{{ p.productBuyPrice | numberFormatFilter }}원</td>
                            <td>{{ p.lessonCount }} 회</td>
                            <td>{{ p.pricePerNum | numberFormatFilter }}원</td>
                            <td>{{ p.lessonUsedCount }}회(결석{{ p.lessonAbsentCount }}회)</td>
                            <td>{{ p.usePrice | numberFormatFilter }}원</td>
                            <td>{{ p.totalBillPrice | numberFormatFilter }}원</td>
                            <td>
                                <span v-if="p.orgLessonStaffId === selectedStaffId">{{ p.totalRemainCount }}회</span>
                            </td>
                            <td>
                                <span v-if="p.orgLessonStaffId === selectedStaffId">
                                    {{ p.totalRemainPrice | numberFormatFilter }}원
                                </span>
                            </td>
                            <td>{{ p.expireEndDate | timestampFilter }}</td>
                            <td>
                                <span v-if="p.orgLessonStaffId === selectedStaffId">
                                    {{ p.accRegCount }}회[총 {{ p.accLessonCount }}회]
                                </span>
                            </td>
                        </tr>
                        <tr class="gray">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{ useCount(person.list) }}회</td>
                            <td>{{ usePrice(person.list) | numberFormatFilter }}원</td>
                            <td>{{ calculatePrice(person.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td>{{ remainPrice(person.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr v-if="person.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="com-table-top">
                <span class="title">OT 회원</span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 90px" />
                        <col style="width: 100px" />
                        <col style="width: 270px" />
                        <col style="width: 100px" />
                        <col style="width: 60px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 80px" />
                        <col style="width: 100px" />
                        <col style="width: 120px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><button>회원명</button></th>
                            <th><button>시작일</button></th>
                            <th><button>이용권명</button></th>
                            <th><button>구매가</button></th>
                            <th><button>횟수</button></th>
                            <th><button>회당단가</button></th>
                            <th><button>사용횟수</button></th>
                            <th><button>소진금액</button></th>
                            <th><button>정산금액</button></th>
                            <th><button>잔여횟수</button></th>
                            <th><button>잔여금액</button></th>
                            <th><button>종료일자</button></th>
                            <th><button>등록횟수</button></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(o, index) in ot.list"
                            :key="index"
                            :class="{ gray: o.orgLessonStaffId !== selectedStaffId }"
                        >
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${o.centerId}`,
                                        query: { customerId: o.centerCustomerId },
                                    }"
                                    class="link"
                                >
                                    {{ o.centerCustomerName }}
                                </router-link>
                            </td>
                            <td>{{ o.expireStartDate | timestampFilter }}</td>
                            <td>
                                {{ convertTicket(o.ticketType) }}
                                <router-link
                                    :to="{
                                        path: `/madmin/member/account/${o.centerId}`,
                                        query: { customerId: o.centerCustomerId, contractId: o.centerContractId },
                                    }"
                                    class="link"
                                >
                                    {{ o.productName }}
                                </router-link>
                                ({{ o.lessonTime }}분)
                            </td>
                            <td>{{ o.productBuyPrice | numberFormatFilter }}원</td>
                            <td>{{ o.lessonCount }} 회</td>
                            <td>{{ o.pricePerNum | numberFormatFilter }}원</td>
                            <td>{{ o.lessonUsedCount }}회(결석{{ o.lessonAbsentCount }}회)</td>
                            <td>{{ o.usePrice | numberFormatFilter }}원</td>
                            <td>{{ o.totalBillPrice | numberFormatFilter }}원</td>
                            <td>
                                <span v-if="o.orgLessonStaffId === selectedStaffId">{{ o.totalRemainCount }}회</span>
                            </td>
                            <td>
                                <span v-if="o.orgLessonStaffId === selectedStaffId">
                                    {{ o.totalRemainPrice | numberFormatFilter }}원
                                </span>
                            </td>
                            <td>{{ o.expireEndDate | timestampFilter }}</td>
                            <td>
                                <span v-if="o.orgLessonStaffId === selectedStaffId">
                                    {{ o.accRegCount }}회[총 {{ o.accLessonCount }}회]
                                </span>
                            </td>
                        </tr>
                        <tr class="gray">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{ useCount(ot.list) }}회</td>
                            <td>{{ usePrice(ot.list) | numberFormatFilter }}원</td>
                            <td>{{ calculatePrice(ot.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td>{{ remainPrice(ot.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr v-if="ot.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="com-table-top">
                <span class="title">
                    듀엣 회원
                    <span class="right-txt">
                        총 {{ useCount(duet.list) }}회, 정산금액 {{ calculatePrice(duet.list)  | numberFormatFilter }}원
                    </span>
                </span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 90px" />
                        <col style="width: 100px" />
                        <col style="width: 270px" />
                        <col style="width: 100px" />
                        <col style="width: 60px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 80px" />
                        <col style="width: 100px" />
                        <col style="width: 120px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><button>회원명</button></th>
                            <th><button>시작일</button></th>
                            <th><button>이용권명</button></th>
                            <th><button>구매가</button></th>
                            <th><button>횟수</button></th>
                            <th><button>회당단가</button></th>
                            <th><button>사용횟수</button></th>
                            <th><button>소진금액</button></th>
                            <th><button>정산금액</button></th>
                            <th><button>잔여횟수</button></th>
                            <th><button>잔여금액</button></th>
                            <th><button>종료일자</button></th>
                            <th><button>등록횟수</button></th>
                        </tr>
                    </thead>
                    <!-- <tbody v-for="(d,index) in duet.list" :key="index"> -->
                    <tbody>
                        <!-- <tr v-for="(t,index) in duet.list[index].details" :key="index"> -->
                        <tr
                            v-for="(d, index) in duet.list"
                            :key="index"
                            :class="{ gray: d.orgLessonStaffId !== selectedStaffId }"
                        >
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${d.centerId}`,
                                        query: { customerId: d.centerCustomerId },
                                    }"
                                    class="link"
                                >
                                    {{ d.centerCustomerName }}
                                </router-link>
                            </td>
                            <td>{{ d.expireStartDate | timestampFilter }}</td>
                            <td>
                                {{ convertTicket(d.ticketType) }}
                                <router-link
                                    :to="{
                                        path: `/madmin/member/account/${d.centerId}`,
                                        query: { customerId: d.centerCustomerId, contractId: d.centerContractId },
                                    }"
                                    class="link"
                                >
                                    {{ d.productName }}
                                </router-link>
                                ({{ d.lessonTime }}분)
                            </td>
                            <td>{{ d.productBuyPrice | numberFormatFilter }}원</td>
                            <td>{{ d.lessonCount }} 회</td>
                            <td>{{ d.pricePerNum | numberFormatFilter }}원</td>
                            <td>{{ d.lessonUsedCount }}회(결석{{ d.lessonAbsentCount }}회)</td>
                            <td>{{ d.usePrice | numberFormatFilter }}원</td>
                            <td>
                                <span >
                                    {{ d.totalBillPrice | numberFormatFilter }}원
                                </span>
                            </td>
                            <td>
                                <span v-if="d.orgLessonStaffId === selectedStaffId">{{ d.totalRemainCount }}회</span>
                            </td>
                            <td>
                                <span v-if="d.orgLessonStaffId === selectedStaffId">
                                    {{ d.totalRemainPrice | numberFormatFilter }}원
                                </span>
                            </td>
                            <td>{{ d.expireEndDate | timestampFilter }}</td>
                            <td>
                                <span v-if="d.orgLessonStaffId === selectedStaffId">
                                    {{ d.accRegCount }}회[총 {{ d.accLessonCount }}회]
                                </span>
                            </td>
                        </tr>
                        <tr class="gray">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{ useCount(duet.list) }}회</td>
                            <td>{{ usePrice(duet.list) | numberFormatFilter }}원</td>
                            <td>{{ calculatePrice(duet.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td>{{ remainPrice(duet.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td></td>


                          
                        </tr>
                        <tr v-if="duet.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="com-table-top">
                <span class="title">
                    그룹 / 쿠폰 회원
                    <span class="right-txt">총 {{ useCount(group.list) }}회, 정산금액 {{ calculatePrice(group.list)  | numberFormatFilter }}원</span>
                    <!--{{group.list.length}}-->
                </span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 90px" />
                        <col style="width: 100px" />
                        <col style="width: 270px" />
                        <col style="width: 100px" />
                        <col style="width: 60px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 80px" />
                        <col style="width: 100px" />
                        <col style="width: 120px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><button>회원명</button></th>
                            <th><button>시작일</button></th>
                            <th><button>이용권명</button></th>
                            <th><button>구매가</button></th>
                            <th><button>횟수</button></th>
                            <th><button>회당단가</button></th>
                            <th><button>사용횟수</button></th>
                            <th><button>소진금액</button></th>
                            <th><button>정산금액</button></th>
                            <th><button>잔여횟수</button></th>
                            <th><button>잔여금액</button></th>
                            <th><button>종료일자</button></th>
                            <th><button>등록횟수</button></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(g, index) in group.list" :key="index"
                        :class="{ gray: g.orgLessonStaffId !== selectedStaffId }">

                        
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${g.centerId}`,
                                        query: { customerId: g.centerCustomerId },
                                    }"
                                    class="link"
                                >
                                    {{ g.centerCustomerName }}
                                </router-link>
                            </td>
                            <td>{{ g.expireStartDate | timestampFilter }}</td>
                            <td>
                                {{ convertTicket(g.ticketType) }}
                                <router-link
                                    :to="{
                                        path: `/madmin/member/account/${g.centerId}`,
                                        query: { customerId: g.centerCustomerId, contractId: g.centerContractId },
                                    }"
                                    class="link"
                                >
                                    {{ g.productName }}
                                </router-link>
                                ({{ g.lessonTime }}분)
                            </td>
                            <td>{{ g.productBuyPrice | numberFormatFilter }}원</td>
                            <td>
                                <span v-if="g.lessonCountType === 'W'">주</span>
                                {{ g.lessonCount }} 회
                            </td>
                            <td>
                                <span v-if="g.lessonCountType === 'T'">{{ g.pricePerNum | numberFormatFilter }}원</span>
                            </td>
                            <td>{{ g.lessonUsedCount }}회(결석{{ g.lessonAbsentCount }}회)</td>
                            <td>
                                <span v-if="g.lessonCountType === 'T'">{{ g.usePrice | numberFormatFilter }}원</span>
                            </td>
                            <td>
                                <span >
                                    {{ g.totalBillPrice | numberFormatFilter }}원
                                </span>
                            </td>
                            <td>
                                <span v-if="g.orgLessonStaffId === selectedStaffId && g.lessonCountType === 'T'">
                                    {{ g.totalRemainCount }}회
                                </span>
                            </td>
                            <td>
                                <span v-if="g.orgLessonStaffId === selectedStaffId && g.lessonCountType === 'T'">
                                    {{ g.totalRemainPrice | numberFormatFilter }}원
                                </span>
                            </td>
                            <td>{{ g.expireEndDate | timestampFilter }}</td>
                            <td>
                                <span v-if="g.orgLessonStaffId === selectedStaffId">
                                    {{ g.accRegCount }}회[총 {{ g.accLessonCount }}회]
                                </span>
                            </td>
                        </tr>
                        <tr class="gray">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{ useCount(group.list) }}회({{ group.total_class_count }}타임)</td>
                            <td>{{ usePrice(group.list) | numberFormatFilter }}원</td>
                            <td>{{ calculatePrice(group.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td>{{ remainPrice(group.list) | numberFormatFilter }}원</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr v-if="group.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="com-table-top">
                <span class="title">
                    매출내역
                    <span class="right-txt">
                        신규매출 {{ staffSales.sumNewData | numberFormatFilter }}원 / 재등록매출
                        {{ staffSales.sumReData | numberFormatFilter }}원 / 총 매출
                        {{ (staffSales.sumNewData + staffSales.sumReData) | numberFormatFilter }}원
                    </span>
                </span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 90px" />
                        <col style="width: 360px" />
                        <col style="width: 330px" />
                        <col style="width: 330px" />
                        <col style="width: 120px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th><button>결제일자</button></th>
                            <th><button>회원명</button></th>
                            <th><button>이용권명</button></th>
                            <th>유효기간</th>
                            <th><button>결제정보</button></th>
                            <th><button>담당강사</button></th>
                            <th><button>등록구분</button></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in staffSales.list" :key="index">
                            <td>{{ item.ccb_buy_dt | timestampFilter }}</td>
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${item.ccb_center_id}`,
                                        query: { customerId: item.ccb_center_cust_id },
                                    }"
                                    class="link"
                                >
                                    {{ item.cust_namee }}
                                </router-link>
                            </td>
                            <td>
                                {{ convertTicket(item.cp_ticket_type_cd) }}

                                <span
                                    :class="{
                                        'type-1': item.cp_ticket_type_cd == 'P',
                                        'type-2': item.cp_ticket_type_cd == 'G',
                                        'type-3': item.cp_ticket_type_cd == 'C',
                                        'type-4': item.cp_ticket_type_cd == 'T',
                                        'type-5': item.cp_ticket_type_cd == 'D',
                                        'type-6': item.cp_ticket_type_cd == 'O',
                                        'type-8': item.cp_ticket_type_cd == 'S',
                                    }"
                                    class="ico"
                                >
                                    {{ convertTicket(item.cp_ticket_type_cd) }}
                                </span>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/account/${item.ccb_center_id}`,
                                        query: {
                                            customerId: item.ccb_center_cust_id,
                                            contractId: item.ccb_center_contract_id,
                                        },
                                    }"
                                    class="link"
                                >
                                    {{ item.ccp_prod_nm }}
                                </router-link>
                            </td>
                            <td>
                                {{ item.ccp_exp_start_dt | timestampFilter }} ~
                                {{ item.ccp_exp_end_dt | timestampFilter }}
                            </td>
                            <!-- <td v-if="!isTurnItem(item)" v-html="getPaymentString(item.ccp_bill_info )"></td> -->
                            <!-- <td v-else><span class="red">[환불]</span> {{item.ccp_turn_bill_price | numberFormatFilter}}원</td> -->
                            <td>
                                <span :class="{ red: item.ccp_ret_yn }">
                                    {{ convertBillCode(item.ccb_pay_type_cd, item.ccp_ret_yn) }}
                                </span>
                                {{ item.ccb_bill_price | numberFormatFilter }}원
                            </td>
                            <td>{{ item.cs_namee }}</td>
                            <td>{{ covertContract(item.ccp_sale_staff_contract_type_cd) }}</td>
                        </tr>
                        <!--
                            <tr>

                            <td>2020-01-02</td>
                            <td>이순신</td>
                            <td>[개인] 필라테스 10회</td>
                            <td>2019-08-02 ~ 2019-12-02</td>
                            <td>[카드] 1,000,000원</td>
                            <td>김윤경</td>
                            <td>신규</td>
                            </tr>
                            <tr>
                            <td>2020-01-02</td>
                            <td>이순신</td>
                            <td>[개인] 필라테스 10회</td>
                            <td>2019-08-02 ~ 2019-12-02</td>
                            <td><span class="red">[환불]</span> 1,000,000원</td>
                            <td>김윤경</td>
                            <td>재등록</td>
                            </tr>
                            -->
                        <tr v-if="staffSales.list.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </span>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';

import XLSX from 'xlsx';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

export default {
    name: 'SalaryResult',
    mixins: [MixinAllowedMenu],
    props: {},
    watch: {
        selectedStaffId(v) {
            this.initBillInfo();
        },
        monthlyPicker() {
            this.initBillInfo();
        },
    },
    computed: {
        selectedMonth() {
            return this.monthlyPicker.format('YYYY-MM');
        },
        personSum() {
            // 개인회원 사용횟수
            let sum = 0;
            for (const i of this.person.list) {
                sum += i.ctb_less_cnt;
            }
            return sum;
        },
        personUseSum() {
            // 소진금액
            let sum = 0;
            for (const i of this.person.list) {
                sum += i.ctb_use_bill_price;
            }
            return sum;
        },
        personCalSum() {
            // 잔여금액
            let sum = 0;
            for (const i of this.person.list) {
                sum += i.ctb_bill_price;
            }
            return sum;
        },
        isDisableSelectStaffs() {
            // 권한 적용여부에 따라 disabled를 해제
            return !(this.isAllowed('PA', 2) || this.isAllowed('PA', 3));
        },
    },
    data() {
        return {
            isLoading: false,
            centerId: '',
            monthlyPicker: moment(), // 년월 설정
            selectedStaffId: parseInt(this.$store.getters['auth/staffId']), // 초기값은 vuex에서
            selectFormStaff: {
                data: [],
                value: [],
            },
            person: {
                list: [],
            },
            ot: {
                list: [],
            },
            duet: {
                list: [],
                details: [],
                totalCount: 0,
                sum: 0,
            },
            group: {
                list: [],
                totalCount: 0,
                sum: 0,
            },
            staffSales: {
                list: [],
                newData: [],
                reData: [],
                sumNewData: 0,
                sumReData: 0,
            },
            newList: [],

            staffId: parseInt(this.$store.getters['auth/staffId']), // 초기값은 vuex에서
            status: 'I',
            statusType: ['근무중인 직원', '퇴사한 직원'],
            statusTypeValue: ['I', 'O'],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            try {
                this.isLoading = true;
                this.centerId = this.$store.getters['auth/cId'];
                Promise.allSettled([this.fetchCenterStaffAllList(), this.refrechAllList()]);
                // 권한이 없는 경우 자기자신
                // if(this.selectFormStaff.value.length > 1) {
                //     this.selectedStaffId = this.selectFormStaff.value[0];
                // }
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },
        async initBillInfo() {
            try {
                this.isLoading = true;
                await this.refrechAllList();
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },
        async refrechAllList() {
            // 값이 바뀌면 재 호출하는 함수.
            await Promise.allSettled([
                this.fetchStaffSales(),
                this.onPersonList(),
                this.onOtList(),
                this.onDuetList(),
                this.onGroupList(),
                this.onDuetAndGroupTotalInfo(),
            ]);
            // 개인리스트 조회
            // ot 리스트 조회
            // 듀엣 목록 조회
            // 그룹리스트 조회
            // 그룹리스트와 듀엣리스트의 정산 금액 합계와 수업 횟수 및 사용 횟수의 총합 구하기
        },
        initList() {
            this.person.list = [];
            this.ot.list = [];
            this.duet.list = [];
            this.group.list = [];
            this.staffSales.list = [];
        },
        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const excelDownloadArray = [];

            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 20 },
                { wch: 15 },
                { wch: 10 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 10 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;
            const ws = XLSX.utils.json_to_sheet(this.staffSales.list); // 매출내역 시트 배열을 넣어야함.
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '성과보고서');
            XLSX.utils.book_append_sheet(wb, ws, '매출내역');
            XLSX.writeFile(wb, '성과보고서.xlsx');
        },
        async fetchCenterStaffAllList() {
            try {
                const staffId = parseInt(this.$store.getters['auth/staffId']);
                const staffName = this.$store.getters['auth/userName'];

                // 자기 자신이 기본값
                let selectFormObj = {
                    data: [staffName],
                    value: [staffId],
                };

                // 권한에 따라 조회 가능한 직원 지정
                if (this.isAllowed('PA', 3)) {
                    // 전체 직원 조회 가능
                    let { data } = await this.getCenterStaffAllList();
                    // 직원 상태에 따른 분기
                    data = data.filter((staff) => {
                        return staff.status === this.status;
                    });
                    data.sort(
                        (
                            a,
                            b // order by 정렬
                        ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                    );
                    selectFormObj = Utils.getSelectFormObjectFromArray('name', 'centerStaffId', data);
                } else if (this.isAllowed('PA', 2)) {
                    // 동일한 팀의 직원 조회 가능
                    let { data } = await this.getCenterSameTeamStaffList();
                    // 직원 상태에 따른 분기
                    data = data.filter((staff) => {
                        return staff.status === this.status;
                    });
                    // 팀이 없는 경우, 기본값인 자신만 노출
                    if (data.length > 0) {
                        selectFormObj = Utils.getSelectFormObjectFromArray('namee', 'center_staff_id', data);
                    }
                }

                this.selectFormStaff.data = selectFormObj.data;
                this.selectFormStaff.value = selectFormObj.value;

                this.selectFormStaff.data.unshift('선택');
                this.selectFormStaff.value.unshift('');
            } catch (e) {
                console.log(e);
            }
        },
        getCenterSameTeamStaffList() {
            const centerStaffId = this.$store.getters['auth/staffId'];
            return api.get(`/admin/api/center/${this.centerId}/staff/${centerStaffId}/sameTeamStaffs`);
        },
        async fetchStaffSales() {
            try {
                const { data } = await this.getCenterStaffAllSum(this.selectedStaffId);
                console.log(data);
                this.staffSales.list = data;
                this.staffSales.sumNewData = 0;
                this.staffSales.sumReData = 0;

                for (const item of data) {
                    if (item.ccp_sale_staff_contract_type_cd === 'N') {
                        this.staffSales.sumNewData += item.ccb_bill_price;
                    } else if (item.ccp_sale_staff_contract_type_cd === 'R') {
                        this.staffSales.sumReData += item.ccb_bill_price;
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        getStaffSalesList() {
            // 스웨거 검색: 센터 매출 리스트 조회
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/list`);
        },
        getCenterStaffAllList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/all/list`);
        },
        getCenterReportPerformance(type) {
            const tickBillDate = this.selectedMonth.replaceAll('-');
            const params = {
                tickBillDate,
            };
            return api.get(
                `/admin/api/center/${this.centerId}/report/preformance/${type}/staff/${this.selectedStaffId}`,
                { params }
            );
        },
        // getCenterStaffAllSumNewRegister(staffId){
        //     return this.getCenterStaffAllSum(staffId, 'N');
        // },
        // getCenterStaffAllSumReregister(staffId){
        //     return this.getCenterStaffAllSum(staffId, 'R');
        // },
        getCenterStaffAllSum(staffId) {
            // 직원 총매출 조회
            const [billYear, billMonth] = this.selectedMonth.split('-');
            const params = {
                billYear,
                billMonth,
            };
            const url = `/admin/api/center/${this.centerId}/salary/staff/${staffId}/total-sales`;
            return api.get(url, { params });
        },
        onClickBtnNextMonth() {
            this.monthlyPicker = moment(this.monthlyPicker).add(1, 'months');
        },
        onClickBtnPrevMonth() {
            this.monthlyPicker = moment(this.monthlyPicker).subtract(1, 'months');
        },
        sumStaffSales(list, fieldName) {
            let sum = 0;

            for (const item of list) {
                if (Utils.isEmpty(item[fieldName])) {
                    continue;
                }

                const paymentArr = item[fieldName].split('|');
                for (const payment of paymentArr) {
                    const [paymentType, amount] = payment.split('_');
                    sum += parseInt(amount);
                }
            }

            return sum;
        },
        isTurnItem(item) {
            return !Utils.isEmpty(item.ccp_turn_bill_price) && item.ccp_turn_bill_price > 0;
        },
        getPaymentString(str) {
            return Utils.getPaymentString(str);
        },
        // 성과보고서 개인목록 조회
        async onPersonList() {
            try {
                const { data } = await this.getPersonList();
                this.person.list = data;
                this.arrangeList(this.person.list);
                console.log('개인목록 조회', this.person.list);
            } catch (error) {
                console.log('error');
                console.log(error);
            }
        },
        // API
        getPersonList() {
            return api.get(
                `/admin/api/center/${this.centerId}/report/preformance/person/staff/${this.selectedStaffId}`,
                {
                    params: {
                        tickBillDate: moment(this.monthlyPicker).format('YYYYMM'),
                    },
                }
            );
        },
        async onOtList() {
            try {
                const { data } = await this.getOtList();
                this.ot.list = data;
                this.arrangeList(this.ot.list);
                console.log('OT목록 조회 ', data);
            } catch (error) {
                console.log(error);
                console.log('OT목록 조회 중 에러가 발생하였습니다.');
            }
        },
        // 성과보고서 OT 목록 조회
        getOtList() {
            return api.get(`/admin/api/center/${this.centerId}/report/preformance/ot/staff/${this.selectedStaffId}`, {
                params: {
                    tickBillDate: moment(this.monthlyPicker).format('YYYYMM'),
                },
            });
        },
        // 듀엣 리스트 조회
        async onDuetList() {
            try {
                const { data } = await this.getDuetList();
                this.duet.list = data;
                this.arrangeList(this.duet.list);
                console.log('듀엣목록 조회', this.duet.list);
            } catch (error) {
                console.log(error);
                console.log('듀엣목록 조회 중 에러가 발생하였습니다.');
            }
        },
        getDuetList() {
            // 스웨거 검색: 성과보고서(듀엣) 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/report/preformance/duet/staff/${this.selectedStaffId}`, {
                params: {
                    tickBillDate: moment(this.monthlyPicker).format('YYYYMM'),
                },
            });
        },
        // 그룹 목록 조회
        async onGroupList() {
            try {
                const { data } = await this.getGroupList();
                this.group.list = data;
                this.arrangeList(this.group.list);
                console.log('그룹목록 조회', this.group.list);
            } catch (error) {
                console.log(error);
                console.log('그룹목록 조회 중 에러가 발생하였습니다.');
            }
        },
        getGroupList() {
            return api.get(
                `/admin/api/center/${this.centerId}/report/preformance/group/staff/${this.selectedStaffId}`,
                {
                    params: {
                        tickBillDate: moment(this.monthlyPicker).format('YYYYMM'),
                    },
                }
            );
        },
        async onDuetAndGroupTotalInfo() {
            try {
                this.loading = true;
                const { data } = await this.getTotalInfo();

                this.group.total_bill_price = 0;
                this.group.total_class_count = 0;
                this.duet.total_bill_price = 0;
                this.duet.total_class_count = 0;

                console.log('총합', data);
                data.forEach((item) => {
                    if (item.less_type_cd === 'D') {
                        this.duet.total_bill_price = item.total_bill_price;
                        this.duet.total_class_count = item.total_class_count;
                    } else if (item.lessonCountType == 'G') {
                        this.group.total_bill_price = item.total_bill_price;
                        this.group.total_class_count = item.total_class_count;
                    }
                });
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
        getTotalInfo() {
            return api.get(
                `/admin/api/center/${this.centerId}/report/preformance/duet/staff/${this.selectedStaffId}/total/billPrice`,
                {
                    params: {
                        tickBillDate: this.monthlyPicker.format('YYYYMM'),
                    },
                }
            );
        },
        // 티켓유형
        convertTicket(type) {
            if (type == 'P') {
                return '[개인]';
            } else if (type == 'O') {
                return '[OT]';
            } else if (type == 'D') {
                return '[듀엣]';
            } else if (type == 'G') {
                return '[그룹]';
            } else if (type == 'C') {
                return '[쿠폰]';
            } else if (type == 'T') {
                return '[이용권]';
            }
        },
        // 합계함수
        totalSum(val, array) {
            let sum = 0;
            for (const i of array) {
                sum += i[val];
            }
            return sum;
        },
        totalSum2(array) {
            console.log('down', array);
            let result = 0;
            array.forEach((g) => {
                result += g.ctb_bill_price;
            });
            return result;
        },
        // 잔여금액 계산
        totalPrice(array) {
            let sum = 0;
            for (const i of array) {
                sum += i.ctb_prod_buy_price - (i.ctb_prod_buy_price / i.ctb_less_cnt) * i.ctb_less_use_cnt;
            }
            return sum;
        },
        covertContract(val) {
            switch (val) {
                case 'N':
                    return '신규';
                case 'R':
                    return '재등록';
                case 'C':
                    return '환불';
            }
        },
        convertBillCode(payType, returnYn) {
            if (returnYn) {
                return '[환불]';
            }

            const type = {
                C: '[카드]',
                L: '[현금]',
                B: '[계좌이체]',
                M: '[마일리지]',
                K: '[키오스크]',
                E: '[기타]',
            };

            return type[payType] !== undefined ? type[payType] : '';
        },
        // convertBillPrice(val){
        //     let str = [];
        //     str = val.split('_');
        //     let price = str[1]

        //     return price
        // },
        // convertType(val){
        //     const type = {
        //         'C' : '[카드]',
        //         'L' : '[현금]',
        //         'B' : '[계좌이체]',
        //         'M' : '[마일리지]',
        //         'E' : '[기타]',
        //         'R' : '[환불]'
        //     }
        //     return (type[val] !== undefined ? type[val] : '--');
        // },
        // 사용횟수
        useCount(array) {
            let sum = 0;
            for (const i of array) {
                sum += i.lessonUsedCount;
            }
            return sum;
        },
        // 소진금액
        usePrice(array) {
            let sum = 0;
            for (const i of array) {

                if( i.lessonCountType != 'U' ) // 무제한 아닌 경우 
                 sum += (i.productBuyPrice / i.lessonCount) * i.lessonUsedCount;
            }
            return Math.floor(sum);
        },
        // 정산금액
        calculatePrice(array) {
            let sum = 0;
            for (const i of array) {

                sum += Number(i.totalBillPrice);
            }
            return sum;
        },
        remainPrice(array) {
            // 잔여금액 계산
            let sum = 0;
            for (const i of array) {
                if( i.lessonCountType != 'U' ) // 무제한 아닌 경우 
                 sum += i.totalRemainPrice;
            }
            return sum;
        },
        convertLessonCountArray(lessonCountArray) {
            let lessonCountString = '';
            const lessonCounts = lessonCountArray.split(',');

            for (const lessonCount of lessonCounts) {
                if (lessonCountString !== '') lessonCountString += ' ';
                lessonCountString += `[${lessonCount}]`;
            }

            return lessonCountString;
        },
        // 목록의 내용을 조정하는 함수
        arrangeList(list) {
            for (const item of list) {
                item.totalLessonAbsentCount = item.totalLessonAbsentCount ? item.totalLessonAbsentCount : 0;
                item.totalLessonJoinCount = item.totalLessonJoinCount ? item.totalLessonJoinCount : 0;
                item.lessonUsedCount = Number(item.lessonUsedCount);
                item.totalBillPrice = Number(item.totalBillPrice);
                if (item.lessonCountType === 'T') {
                    item.pricePerNum = Math.floor(item.productBuyPrice / item.lessonCount);
                    item.usePrice = Math.floor((item.productBuyPrice / item.lessonCount) * item.lessonUsedCount);

                    if (item.orgLessonStaffId === this.selectedStaffId) {
                        item.totalRemainPrice =
                            item.productBuyPrice -
                            Math.floor((item.productBuyPrice / item.lessonCount) * Number(item.totalUsedCount));
                        item.totalRemainCount = item.lessonCount - item.totalUsedCount;
                    } else {
                        item.totalRemainPrice = 0;
                        item.totalRemainCount = 0;
                    }
                }
            }
        },
        onSelectedStaff(value) {
            /**
             * 아래와 같이 정산 내역에 나타나 있는 목록들을 초기화 시켜주는 이유는 오류 때문이 아님.
             * 해당 부분을 없애면 데이터를 받아오는 동안에 마치 오류가 나는 것처럼 느껴지기 때문임.
             */
            this.initList();
            this.selectedStaffId = value;
            this.staffId = value;
        },
    },
};
</script>
<style lang="scss"></style>
